import { authConstants } from './../constants/auth-constants';
import  AgentsService  from './../services/agents-service'

export const agentsList = (data) => async (dispatch) => {
    try {
      const res = await AgentsService.getAgents();
  
      dispatch({
        type: authConstants.AGENT_LIST,
        payload: res.data,
      });
  
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  };
  